export default {
  carousel: {
    imgMissing: 'Missing Image',
    pendingImg: 'Please select the image displayed in the control bar below.',
    upload: 'Upload Page',
    uploading: 'Uploading',
    add: 'New Page',
  },
  pages: {
    systemPage: {
      home: 'Home',
      mouseRt: 'Button Actuation',
    },
    side: {
      title: 'Component Styles',
      tabPreset: 'Preset',
      tabPicture: 'Picture',
      tabText: 'Text',
    },
    picture: {
      add: 'Only JPG, PNG, and GIF files can be added.',
    },
    text: {
      inputPlaceholder: 'Plase input the text',
      fontSize: 'Font Size',
      fontSmall: 'S',
      fontNormal: 'M',
      fontLarge: 'L',
      fontColor: 'Font Color',
      bgColor: 'Background Color',
      preview: 'Preview',
      minimize: 'Minimize',
    },
  },
  player: {
    displayTip: '*Check the box to display',
    sortTip: '*Drag to sort',
    tabDisplay: 'Custom Display',
    tabSort: 'Playback Order',
    imgMissing: 'Missing Image',
    minDisplay: 'Display at least one piece of content',
  },
  routeDialog: {
    title: 'Not Upload Prompt',
    description:
      "If you switch pages, any records that haven't been uploaded will be cleared. Would you like to display them on the screen first?",
    cancelText: 'Leave',
    confirmText: 'Upload Page',
  },
  pictureEditDialog: {
    title: 'Asset Naming',
    placeholder: 'Please input the asset name.',
    error: 'The name cannot exceed {limit} characters.',
  },
  pictureDeleteDialog: {
    title: 'Asset Delete',
    occupancyTip:
      'This asset will be removed from the app, but your device screen will keep displaying the current frame. You will need to re-upload it to edit or apply it again.',
    confirmTip:
      "Once deleted, you'll need to upload it again. Confirm that you want to delete this file.",
  },
  carouselDeleteDialog: {
    title: 'Delete Page',
    description:
      'Once deleted, this page will be removed from the carousel. Confirm deletion of this page.',
  },
}
